import _ from "lodash";
import { ActionMenuItem } from "../../components/action-menu/ActionMenuItem";

export function sortAndDispatchActions<TItem extends ActionMenuItem>(
    currentActions: TItem[],
    newActions: TItem[],
    dispatchCallback: (actions: TItem[]) => void
) {
    const sortedActions = newActions.sort((left, right) => (left.order ?? 0) - (right.order ?? 0));

    if (!_.isEqual(currentActions, sortedActions)) {
        dispatchCallback(sortedActions);
    }
}
